<div style="height: 35px; width: 250px">
  <canvas [attr.id]="elementId"></canvas>
</div>
